import { useState } from 'react';
import { OrbitSuccess } from '#components/atoms/illustrations/OrbitSuccess.tsx';
import { CenteredLayout } from '#components/patterns/layouts/centered/CenteredLayout.tsx';
import { MainLayout } from '#components/patterns/layouts/main/MainLayout.tsx';
import { useAuth } from '#global/context/auth/useAuth.tsx';
import { PriorityBanner } from '#screens/support/contact/priority-banner/PriorityBanner.tsx';
import { page, Titled } from '#util/title.ts';
import { ConnectWithUs } from '../connect/ConnectWithUs.tsx';
import { ContactUsForm } from '../form/ContactUsForm.tsx';
import styles from './ContactUsPage.module.css';

export function ContactUsPage() {
  const { user } = useAuth();
  const [successful, setSuccessful] = useState(false);

  // Wait until we have the user data
  if (!user) return null;

  function handleSuccess() {
    setSuccessful(true);
  }

  return (
    <Titled title={() => page('Contact us')}>
      {successful ?
        <CenteredLayout Illustration={OrbitSuccess}>
          <h2 className="h3">We received your message</h2>
          <p className="p text-center color-lowlight">
            Thank you for your reaching out. We will review your message and get back to you as soon as we can.
          </p>
        </CenteredLayout>
      : <MainLayout header="Contact us">
          <div className={styles.ContactUsPage}>
            <ContactUsForm
              className={styles.ContactUsPage_form}
              email={user.email}
              orgId={user.organizationID}
              onSuccess={handleSuccess}
            />
            <div className={styles.ContactUsPage_plan}>
              <PriorityBanner />
            </div>
            <div className={styles.ContactUsPage_connect}>
              <ConnectWithUs />
            </div>
          </div>
        </MainLayout>
      }
    </Titled>
  );
}
